import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import Container                                from '@material-ui/core/Container'
import Grid                                     from '@material-ui/core/Grid'
import PropTypes                                from 'prop-types'
import Typography                               from '@material-ui/core/Typography'

import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import { node_server }                          from '../Helpers'

const ShowHistoryPhoto = ({ entry }) => {
   
   const [ photoObject,    setPhotoObject    ]  =  useState({})

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + `photo/${entry.photoId}`)
         .then( res => res.data )
         .then( data => {
            setPhotoObject(data)
         })
         .catch( (error) => {
            console.error(error)
         })

   }, [])

       return (
        <Box style={{marginTop: '3rem'}} >
            <Container style={{marginBottom: '2rem'}} >
               <Grid container justifyContent='left' >
                  <img
                     style={{width: `${Number(entry.width)}%`}}
                     alt={`${photoObject.caption}`}
                     src={photoObject.fullFilename}
                  />
               </Grid>
               <Grid container justifyContent='left' style={{ marginTop: '1rem' }} >
                  {entry.entry === ''
                     ?
                     <Typography align='left' style={{width: `${entry.width}%`}} >
                        {photoObject.caption}
                     </Typography>
                  :
                     <Typography align='left' style={{width: '75%'}} >
                        {entry.entry}
                     </Typography>
                  }
               </Grid>
            </Container>
        </Box>
    )
}

ShowHistoryPhoto.propTypes = {
    entry:        PropTypes.object
}

export default ShowHistoryPhoto